@if(isLoading | async){
    <div class="loading-overlay">
         <div class="loader"></div>
    </div>
}

